import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 18V2H6v16h16zm-11-6l2.03 2.71L16 11l4 5H8l3-4zM2 6v16h16v-2H4V6H2z"
}), 'CollectionsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CollectionsSharp.js
// module id = 2876
// module chunks = 2